import buttons from "./components/buttons";
import countryList from "./components/country_list";
import dashboardWrapper from "./components/dashboard-wrapper";
import dateTime from "./components/date_time";
import dnsTable from "./components/dns-table";
import errorCodes from "./components/error_codes";
import inputs from "./components/inputs";
import sideNav from "./components/side-nav";
import tableFilter from "./components/table_filter";
import validation from "./components/validation";
import driverTour from "./driver-tour";
import administrator from "./sections/administrator";
import auditLog from "./sections/audit-log";
import backOffice from "./sections/back-office/index";
import billing from "./sections/billing";
import company from "./sections/company";
import dadup from "./sections/dadup/index";
import debtor from "./sections/debtor";
import dnsManagement from "./sections/domain/dns-management";
import domain from "./sections/domain/index";
import featuresBugs from "./sections/features-bugs";
import header from "./sections/header";
import home from "./sections/home";
import ip_address from "./sections/ip-address";
import pbs from "./sections/pbs";
import privateNetwork from "./sections/private-network";
import relations from "./sections/relations";
import shared from "./sections/shared/index";
import signIn from "./sections/sign_in";
import signUp from "./sections/sign_up";
import vps from "./sections/vps/index";

const labels = {
	administrator: administrator,
	audit_log: auditLog,
	back_office: backOffice,
	billing: billing,
	buttons: buttons,
	company: company,
	country_list: countryList,
	dadup: dadup,
	dashboard_wrapper: dashboardWrapper,
	date_time: dateTime,
	debtor: debtor,
	dns_management: dnsManagement,
	dns_table: dnsTable,
	domain: domain,
	driver_tour: driverTour,
	error_codes: errorCodes,
	features_bugs: featuresBugs,
	header: header,
	home: home,
	inputs: inputs,
	ip_address: ip_address,
	pbs: pbs,
	private_network: privateNetwork,
	relations: relations,
	shared: shared,
	side_nav: sideNav,
	sign_in: signIn,
	sign_up: signUp,
	table_filter: tableFilter,
	validation: validation,
	vps: vps,
};

export default labels;
